<template>
  <div
    class="bg-listContextMenu"
    @click.prevent="closeContextMenu"
    :style="show"
  >
    <div class="listContextMenu" :style="style" ref="listContextMenu">
      <div class="listContextMenu__text" @click="handleRenameTask">
        <span>{{ $t("task.context_menu.rename") }}</span>
      </div>
      <div class="listContextMenu__text" @click="copy">
        <span>{{ $t("task.context_menu.copy_link") }}</span>
      </div>
      <div
        class="listContextMenu__text border"
        v-if="!task.parent && !task.done"
        @mouseover="show_submenu.move = true"
        @mouseleave="show_submenu.move = false"
      >
        <span
          >{{ $t("task.context_menu.move_to") }}
          <svg
            width="9"
            height="5"
            viewBox="0 0 9 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.576117 0.99729C0.70958 0.997029 0.838921 1.04351 0.941688 1.12867L4.00335 3.68766L7.07071 1.22006C7.12914 1.17261 7.19637 1.13718 7.26854 1.1158C7.3407 1.09442 7.41638 1.08751 7.49122 1.09547C7.56607 1.10343 7.6386 1.12611 7.70465 1.16219C7.77071 1.19828 7.82898 1.24706 7.87611 1.30574C7.92356 1.36417 7.95899 1.4314 7.98037 1.50356C8.00176 1.57573 8.00866 1.65141 8.0007 1.72625C7.99274 1.8011 7.97006 1.87363 7.93398 1.93968C7.89789 2.00573 7.84911 2.064 7.79043 2.11114L4.3632 4.87006C4.261 4.95407 4.13279 5 4.00049 5C3.86818 5 3.73998 4.95407 3.63777 4.87006L0.210546 2.01403C0.152707 1.96608 0.104896 1.90719 0.0698514 1.84073C0.0348067 1.77427 0.0132165 1.70156 0.00631857 1.62674C-0.00057888 1.55193 0.0073514 1.47649 0.0296535 1.40474C0.0519562 1.333 0.0881925 1.26635 0.136289 1.20864C0.189442 1.14311 0.256451 1.09017 0.332499 1.05363C0.408547 1.01709 0.491746 0.997848 0.576117 0.99729Z"
              fill="#9A9A9A"
            ></path>
          </svg>
        </span>
        <div
          class="listContextMenu__submenu move__submenu"
          :class="show_submenu.move ? 'show' : ''"
        >
          <div
            class="listContextMenu__text"
            @mouseover="show_submenu.section = true"
            @mouseleave="show_submenu.section = false"
          >
            <span
              >{{ $t("task.context_menu.section") }}
              <svg
                width="9"
                height="5"
                viewBox="0 0 9 5"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.576117 0.99729C0.70958 0.997029 0.838921 1.04351 0.941688 1.12867L4.00335 3.68766L7.07071 1.22006C7.12914 1.17261 7.19637 1.13718 7.26854 1.1158C7.3407 1.09442 7.41638 1.08751 7.49122 1.09547C7.56607 1.10343 7.6386 1.12611 7.70465 1.16219C7.77071 1.19828 7.82898 1.24706 7.87611 1.30574C7.92356 1.36417 7.95899 1.4314 7.98037 1.50356C8.00176 1.57573 8.00866 1.65141 8.0007 1.72625C7.99274 1.8011 7.97006 1.87363 7.93398 1.93968C7.89789 2.00573 7.84911 2.064 7.79043 2.11114L4.3632 4.87006C4.261 4.95407 4.13279 5 4.00049 5C3.86818 5 3.73998 4.95407 3.63777 4.87006L0.210546 2.01403C0.152707 1.96608 0.104896 1.90719 0.0698514 1.84073C0.0348067 1.77427 0.0132165 1.70156 0.00631857 1.62674C-0.00057888 1.55193 0.0073514 1.47649 0.0296535 1.40474C0.0519562 1.333 0.0881925 1.26635 0.136289 1.20864C0.189442 1.14311 0.256451 1.09017 0.332499 1.05363C0.408547 1.01709 0.491746 0.997848 0.576117 0.99729Z"
                  fill="#9A9A9A"
                ></path>
              </svg>
            </span>
            <div
              class="listContextMenu__submenu section__submenu"
              :class="show_submenu.section ? 'show' : ''"
            >
              <div class="listContextMenu__text" @click="section_move('')">
                <span>{{ $t("task.context_menu.no_section") }}</span>
              </div>
              <div
                class="listContextMenu__text"
                v-for="section in sections"
                :key="section._id"
                @click="section_move(section._id)"
              >
                <span>{{ section.name }}</span>
              </div>
            </div>
          </div>
          <div
            class="listContextMenu__text"
            @mouseover="show_submenu.list = true"
            @mouseleave="show_submenu.list = false"
          >
            <span
              >{{ $t("task.context_menu.list") }}
              <svg
                width="9"
                height="5"
                viewBox="0 0 9 5"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.576117 0.99729C0.70958 0.997029 0.838921 1.04351 0.941688 1.12867L4.00335 3.68766L7.07071 1.22006C7.12914 1.17261 7.19637 1.13718 7.26854 1.1158C7.3407 1.09442 7.41638 1.08751 7.49122 1.09547C7.56607 1.10343 7.6386 1.12611 7.70465 1.16219C7.77071 1.19828 7.82898 1.24706 7.87611 1.30574C7.92356 1.36417 7.95899 1.4314 7.98037 1.50356C8.00176 1.57573 8.00866 1.65141 8.0007 1.72625C7.99274 1.8011 7.97006 1.87363 7.93398 1.93968C7.89789 2.00573 7.84911 2.064 7.79043 2.11114L4.3632 4.87006C4.261 4.95407 4.13279 5 4.00049 5C3.86818 5 3.73998 4.95407 3.63777 4.87006L0.210546 2.01403C0.152707 1.96608 0.104896 1.90719 0.0698514 1.84073C0.0348067 1.77427 0.0132165 1.70156 0.00631857 1.62674C-0.00057888 1.55193 0.0073514 1.47649 0.0296535 1.40474C0.0519562 1.333 0.0881925 1.26635 0.136289 1.20864C0.189442 1.14311 0.256451 1.09017 0.332499 1.05363C0.408547 1.01709 0.491746 0.997848 0.576117 0.99729Z"
                  fill="#9A9A9A"
                ></path>
              </svg>
            </span>
            <div
              class="listContextMenu__submenu list__submenu"
              :class="show_submenu.list ? 'show' : ''"
              v-if="lists.filter((e) => e._id != list_id).length > 0"
            >
              <div
                class="listContextMenu__text"
                v-for="list in lists"
                :key="list._id"
                @click="list_move(list._id)"
                :style="list_id == list._id ? 'display: none' : ''"
              >
                <span>{{ list.name }}</span>
              </div>
            </div>
            <div
              class="listContextMenu__submenu list__submenu"
              :class="show_submenu.list ? 'show' : ''"
              v-else
            >
              <div class="listContextMenu__text">
                <span>{{ $t("task.context_menu.no_lists") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="listContextMenu__text red" @click="remove">
        <span>{{ $t("task.context_menu.delete") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { EventEmitter } from "../../main";

export default {
  data() {
    return {
      style: "",
      show: "display: none",
      task_id: "",
      list_id: "",
      show_submenu: {
        move: false,
        list: false,
        section: false,
      },
      sections: [],
      lists: [],
      task: "",
    };
  },
  computed: {
    ...mapGetters([
      "getLists",
      "getPlan",
      "getProjects",
      "getChats",
      "get_unreaded_messages_in_project",
      "get_flag_for_unreaded",
      "getLastChat",
      "get_flag_for_last_chat",
      "getUserData",
      "getRenderUserData",
      "getLists",
      "getFolderLists",
      "get_flag_for_tasks",
      "getTasks",
      "getSubTask",
      "getCompletedTasks",
      "get_change_shortcuts_render",
      "getListsMentions",
    ]),
  },
  mounted() {
    EventEmitter.$on("ContextMenu_open", (position_menu) => {
      this.lists = [];

      this.show = "display: block;opacity: 0";
      this.task_id = position_menu.task_id;
      this.list_id = position_menu.list_id;
      this.task = position_menu.task;
      this.sections = this.getProjects.filter(
        (list) => list._id == this.list_id
      );
      this.sections = this.sections[0] ? this.sections[0].sections : [];

      let lists = this.getProjects.filter((list) => list._id != this.list_id);

      let lists2 = this.getLists["list"] ? this.getLists["list"] : [];
      let folders = this.getLists["folder"] ? this.getLists["folder"] : [];

      this.lists = this.lists.concat(lists2);

      folders.forEach((e) => {
        if (e.lists) {
          e.lists.forEach((a) => {
            this.lists.push(a);
          });
        }
      });

      setTimeout(() => {
        let chat_body = document.querySelector(".project_body")
          ? document.querySelector(".project_body")
          : document.querySelector(".tasks_body");
        let menu = this.$refs.listContextMenu;

        let top =
          position_menu.y + menu.clientHeight > chat_body.clientHeight
            ? position_menu.y - menu.clientHeight
            : position_menu.y;
        let left =
          position_menu.x + menu.clientWidth > chat_body.clientWidth
            ? position_menu.x - menu.clientWidth
            : position_menu.x;

        if (chat_body && menu) {
          if (
            position_menu.x + menu.clientWidth + 100 >
            chat_body.clientWidth
          ) {
            if (lists.length > 0 || this.sections.length > 0) {
              // document.querySelector('.listContextMenu__submenu').classList.remove('left-position')
              // console.log(chat_body.clientWidth, left + menu.clientWidth + 500)
              if (chat_body.clientWidth < left + menu.clientWidth + 450) {
                if (document.querySelector(".move__submenu")) {
                  document.querySelector(".move__submenu").style.left =
                    "-165px";
                  document.querySelector(".section__submenu").style.left =
                    "-" +
                    document.querySelector(".section__submenu").clientWidth +
                    "px";
                  document.querySelector(".list__submenu").style.left =
                    "-" +
                    document.querySelector(".list__submenu").clientWidth +
                    "px";
                  document
                    .querySelectorAll(".listContextMenu__submenu")
                    .forEach((e) => {
                      e.style.transform = "none";
                      e.style.right = "auto";
                    });
                }
              } else {
                if (document.querySelector(".move__submenu")) {
                  document.querySelector(".move__submenu").style.right =
                    "165px";
                  document.querySelector(".section__submenu").style.right =
                    "165px";
                  document.querySelector(".list__submenu").style.right =
                    "165px";
                }
              }
            }
          }

          if (document.querySelector(".move__submenu")) {
            let h =
              document.querySelector(".list__submenu").clientHeight >
              document.querySelector(".section__submenu").clientHeight
                ? document.querySelector(".list__submenu").clientHeight
                : document.querySelector(".section__submenu").clientHeight;

            if (
              position_menu.y + menu.clientHeight + h >
              chat_body.clientHeight
            ) {
              if (lists.length > 0 || this.sections.length > 0) {
                document.querySelector(".section__submenu").style.top = "auto";
                document.querySelector(".list__submenu").style.top = "auto";
                document.querySelector(".section__submenu").style.bottom = "0";
                document.querySelector(".list__submenu").style.bottom = "0";
              }
            }
          }

          this.style = `top: ${top}px; left: ${left}px`;
          this.show = "display: block;opacity: 1";
        }
      }, 10);
    });
  },
  methods: {
    ...mapActions(["socket_change_order"]),
    handleRenameTask() {
      EventEmitter.$emit("RenameTaskFromContext", this.task_id);
    },
    closeContextMenu() {
      this.show_submenu = {
        move: false,
        list: false,
        section: false,
      };

      if (document.querySelector(".move__submenu")) {
        document.querySelector(".move__submenu").style = "";
        document.querySelector(".section__submenu").style = "";
        document.querySelector(".list__submenu").style = "";
      }

      this.show = "display: none";
      // EventEmitter.$emit('listContextMenu_close', true)
    },
    section_move(section_id) {
      this.show_submenu = {
        move: false,
        list: false,
        section: false,
      };

      let new_order_position;

      if (section_id) {
        let uncompleted_tasks = [];
        let new_order = [];

        if (this.getTasks[this.list_id]) {
          this.getTasks[this.list_id].forEach((e) => {
            if (e) {
              if (e.section == section_id) {
                e.order = e.order + 1;
                uncompleted_tasks.push(e);
              }
            }
          });
        }

        // if (uncompleted_tasks.length > 0) {
        uncompleted_tasks.unshift({
          _id: this.task_id,
          order: 0,
        });

        uncompleted_tasks.sort(function (a, b) {
          return a.order - b.order;
        });

        uncompleted_tasks.forEach((e, i) => {
          if (e) {
            new_order.push({
              task_id: e._id,
              order: i,
              section_id: section_id,
            });
          }
        });
        // } else {

        // }

        new_order_position = {
          out: true,
          new_order: new_order,
          project_id: this.list_id,
          section_id: section_id,
        };
        this.socket_change_order({
          new_order_position,
          add_global: true,
          working_out: true,
        });
      } else {
        let uncompleted_tasks = [];

        if (this.getTasks[this.list_id]) {
          this.getTasks[this.list_id].forEach((e) => {
            if (e) {
              if (!e.parent && !e.section) {
                e.order = e.order + 1;
                uncompleted_tasks.push(e);
              }
            }
          });
        }

        uncompleted_tasks.unshift({
          _id: this.task_id,
          order: 0,
        });

        uncompleted_tasks.sort(function (a, b) {
          return a.order - b.order;
        });

        let new_order = [];

        uncompleted_tasks.forEach((e, i) => {
          if (e) {
            new_order.push({
              task_id: e._id,
              order: i,
            });
          }
        });

        new_order_position = {
          out: true,
          new_order: new_order,
          project_id: this.list_id,
        };
        this.socket_change_order({
          new_order_position,
          add_global: true,
          working_out: true,
        });
      }
    },
    list_move(list_id) {
      this.show_submenu = {
        move: false,
        list: false,
        section: false,
      };

      let a = false;

      this.$w_plan(
        this,
        this.getPlan,
        "task",
        () => {
          this.setMessage({
            key_message: "warning",
            message: this.$planMessages.task.en,
            plan: true,
          });
          a = true;
        },
        list_id
      );

      if (a) {
        return;
      }

      const tasks = [];

      this.getTasks[list_id].forEach((e) => {
        if (e) {
          if (!e.parent && !e.section) {
            tasks.push(e);
          }
        }
      });

      tasks.sort(function (a, b) {
        return a.order - b.order;
      });

      let subtasks = this.getSubTask.filter((e) => e.parent == this.task_id);
      let array_subtask = [];

      subtasks.forEach((e) => {
        array_subtask.push(e._id);
      });

      let data = {
        remove_project_id: this.list_id,
        add_project_id: list_id,
        subtasks: array_subtask,
        task_id: this.task_id,
        order: tasks.length == 0 ? 0 : tasks.length + 1,
      };

      this.$socket.emit("IN_TaskMove", data);

      EventEmitter.$emit("RemoveTaskSection", {
        task_id: this.task_id,
        project_id: this.list_id,
        section_id: "",
      });
      EventEmitter.$emit("TaskMove_DeleteTask", this.task_id);

      if (this.$route.name == "Search") {
        EventEmitter.$emit("RenderSearch");
      }
    },
    copy() {
      let url = "";
      if (this.getUserData.shortcut_inbox == this.list_id) {
        url =
          window.location.origin +
          "/inbox/" +
          this.list_id +
          "/task/" +
          this.task_id;
      } else {
        url =
          window.location.origin +
          "/project/" +
          this.list_id +
          "/task/" +
          this.task_id;
      }
      this.$clipboard(url);
    },
    remove() {
      // EventEmitter.$emit('removeTask', this.task_id)
      let data = {
        type: "task_remove",
        data: {
          text: this.$t("task.messages.delete_task"),
          cancel: this.$t("app.alert.cancel"),
          delete: this.$t("app.alert.delete"),
        },
        list: this.task_id,
      };
      EventEmitter.$emit("OpenPopup", data);
    },
  },
};
</script>
